import React, { useState, useEffect } from "react";
import {
  Tabs,
  Tab,
  Box,
  Button,
  Container,
  Paper,
  IconButton,
} from "@mui/material";
import { getAccountingYears } from "../../../apis/E-conomic/AccountingEntriesByYearApi";
import { getEPRAnswers } from "../../../apis/Business/EPRAnswers";
import EPRAccountingYears from "./components/EPRAccountingYears";
import EPRCarousel from "./components/EPRQuestions/EPRCarousel";
import { DnDParents } from "./components/DnDParents";
import Step2Table from "./components/ERPTable";
import { updateEconomicSupplierBulk } from "../../../apis/Business/EconomicSupplierBulk";
import "./index.css";
import nextBtn from "../../../assets/design-revamp-company/company-epr/next-btn-erp.svg";
import nextStep1Icon from "../../../assets/design-revamp-company/company-epr/next-step1-icon.svg";
import questionBtn from "../../../assets/design-revamp-company/company-epr/question-btn.svg";
import prevBtn from "../../../assets/design-revamp-company/company-epr/prev-btn.svg";
import questionIcon from "../../../assets/design-revamp-company/company-epr/question-icon.svg";
import QAModalInfo from "./components/QAModalInfo";
import { getYearTabList } from "../../../apis/Business/Business";
import disabledNextSummary from "../../../assets/design-revamp-company/company-epr/disabled-next-summary.svg";
import enabledNextSummary from "../../../assets/design-revamp-company/company-epr/enabled-next-summary.svg";
import nextBtnSummary from "../../../assets/design-revamp-company/company-epr/next-btn-white.svg";
import infoIcon from "../../../assets/design-revamp-company/company-epr/info-icon.svg";
import AllocateModal from "./components/QAModalInfo/AllocateModal";
import { useNavigate } from "react-router-dom";
import FinishModal from "./components/QAModalInfo/FinishModal";
import { useTranslation } from "react-i18next";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`epr-tabpanel-${index}`}
      aria-labelledby={`epr-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const EPRWorkflowTabs = ({
  businessId,
  chosenYear,
  setChosenYear,
  setYearEcoApi,
  yearEcoApi,
  accountingPeriod,
  setAccountingPeriod,
  allocatedYear,
  setAllocatedYear,
  setActiveIndex,
  submittedData,
  isEdit,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [accountingYears, setAccountingYears] = useState([]);
  const [isQASubmitted, setIsQASubmitted] = useState(false);
  const [continueBin, setContinueBin] = useState(() => {
    if (isEdit && submittedData) {
      return Array.isArray(submittedData)
        ? submittedData
        : typeof submittedData === "object" &&
          Object.keys(submittedData).length > 0
        ? Object.values(submittedData)
        : [];
    }
    return [];
  });
  const [activeTab, setActiveTab] = useState(0);
  const [selectedRowsInStep2, setSelectedRowsInStep2] = useState([]);
  const [isSubmitYear, setIsSubmitYear] = useState(false);
  const [openQAModal, setOpenQAModal] = useState(false);
  const [yearsOptions, setYearsOptions] = useState([]);
  const [openInfoModal, setOpenInfoModal] = useState(false);
  const [openFinishModal, setOpenFinishModal] = useState(false);
  const [existingQA, setExistingQA] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleInfoClick = (e) => {
    e.stopPropagation();
    setOpenInfoModal(true);
  };

  // Fetch accounting years
  useEffect(() => {
    getAccountingYears({ setAccountingYears: setAccountingYears });
  }, []);

  useEffect(() => {
    getYearTabList({ setYearTabList: setYearsOptions });
  }, []);

  useEffect(() => {
    if (businessId && chosenYear) {
      setIsLoading(true);
      getEPRAnswers({
        businessId: businessId,
        setIsQASubmitted: setIsQASubmitted,
        year: chosenYear,
        period: accountingPeriod,
        setObjects: (data) => {
          setExistingQA(data);
          setIsLoading(false);
        },
      });
    }
  }, [businessId, chosenYear, accountingPeriod]);

  useEffect(() => {
    setActiveIndex(activeTab);
  }, [activeTab, setActiveIndex]);

  useEffect(() => {
    setContinueBin(submittedData);
  }, [submittedData]);

  const updateEconomicSuppliers = (selectedRows) => {
    const objectsToUpdate = selectedRows.map((row) => ({
      id: row.id,
      business: businessId,
      facility:
        row.facility &&
        typeof row.facility === "object" &&
        Object.keys(row.facility).length > 0
          ? row.facility.value
          : row.facility,
      facility_id: row.facility_id,
      category:
        row.category &&
        typeof row.category === "object" &&
        Object.keys(row.category).length > 0
          ? row.category.value
          : row.category,
      subcategory:
        row.subcategory &&
        typeof row.subcategory === "object" &&
        Object.keys(row.subcategory).length > 0
          ? row.subcategory.value
          : row.subcategory,
      emission_factor:
        row.emission_factor &&
        typeof row.emission_factor === "object" &&
        Object.keys(row.emission_factor).length > 0
          ? row.emission_factor.value
          : row.emission_factor,
      entry_number: row.entry_number,
      text: row.text,
      amount: row.amount,
      typedb: row.typedb,
      invoice_date: row.invoice_date,
      account_name: row.account_name,
      account_number: row.account_number,
      is_selected: true,
      year_api: yearEcoApi,
    }));

    if (objectsToUpdate.length > 0) {
      updateEconomicSupplierBulk({
        businessId,
        objectsToUpdate,
        objects: selectedRowsInStep2,
        setObjects: setSelectedRowsInStep2,
        use_swal: true,
      });
    }
  };

  const handleNextTab = () => {
    switch (activeTab) {
      case 0:
        setActiveTab(1);
        break;
      case 1:
        setActiveTab(2);
        break;
      case 2:
        if (selectedRowsInStep2.length > 0) {
          updateEconomicSuppliers(selectedRowsInStep2);
          setOpenFinishModal(true);
        }
        break;
      // case 3:
      //   if (selectedRowsInStep2.length > 0) {
      //     updateEconomicSuppliers(selectedRowsInStep2);
      //   }
      //   setOpenFinishModal(true);
      //   break;
      default:
        break;
    }
  };

  const handlePrevTab = () => {
    switch (activeTab) {
      case 1:
        setActiveTab(0);
        break;
      case 2:
        setActiveTab(1);
        break;
      // case 3:
      //   setActiveTab(2);
      //   break;
      default:
        break;
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleProceedModal = () => {
    if (isSubmitYear && isQASubmitted) {
      setActiveTab(1);
    } else {
      setActiveTab(0);
    }
    setOpenQAModal(false);
  };

  const handleNavigate = () => {
    setOpenFinishModal(false);
    navigate("/company");
  };
  return (
    <Container
      maxWidth="lg"
      sx={{
        mt: 2,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        paddingLeft: 0,
        paddingRight: 0,
      }}
    >
      <Paper
        elevation={0}
        className={activeTab === 0 ? "erp-tabs-bg" : ""}
        sx={{
          backgroundColor:
            activeTab === 0 ? "rgba(12, 55, 106, 0.05)" : "transparent",
          width: "100%",
        }}
      >
        {activeTab === 0 && (
          <div
            style={{
              position: "absolute",
              top: "-5px",
              left: "-10px",
              zIndex: 4,
              cursor: "pointer",
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpenQAModal(true);
            }}
          >
            <img
              src={questionBtn}
              alt="Info Q&A button"
              width={40}
              height={40}
            />
          </div>
        )}
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          aria-label="EPR workflow tabs"
          sx={{
            ".MuiTabs-indicator": {
              display: "none",
            },
            "& .MuiTabs-flexContainer": {
              gap: "6px",
            },
          }}
        >
          <Tab sx={{ display: "none" }} />
          {activeTab !== 0 && [
            <Tab
              key="invoices"
              className="erp-tab-bg "
              label="Select invoices for emission"
              sx={{
                ...(activeTab === 1
                  ? {
                      backgroundColor: "rgba(12, 55, 106, 0.8)",
                      color: "white",
                      "&.Mui-selected": {
                        color: "white !important",
                      },
                    }
                  : {
                      backgroundColor: "rgba(12, 55, 106, 0.5)",
                      color: "white",
                    }),
                textTransform: "capitalize",
              }}
            />,
            <Tab
              key="allocation"
              className="erp-tab-bg "
              label={
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  Allocate Emissions & facilities for purchase
                  <img
                    src={infoIcon}
                    alt="Info Icon"
                    width={20}
                    height={20}
                    onClick={handleInfoClick}
                    style={{ cursor: "pointer", marginLeft: "8px" }}
                  />
                </div>
              }
              disabled={continueBin.length === 0}
              sx={{
                ...(activeTab === 2
                  ? {
                      backgroundColor: "rgba(12, 55, 106, 0.8)",
                      color: "white",
                      "&.Mui-selected": {
                        color: "white !important",
                      },
                    }
                  : {
                      backgroundColor: "rgba(12, 55, 106, 0.5)",
                      color: "white",
                    }),
                textTransform: "capitalize",
              }}
            />,
            // <Tab
            //   key="overview"
            //   className="erp-tab-bg "
            //   label="Overview"
            //   disabled={selectedRowsInStep2.length === 0}
            //   sx={{
            //     ...(activeTab === 3
            //       ? {
            //           backgroundColor: "rgba(12, 55, 106, 0.8)",
            //           color: "white",
            //           "&.Mui-selected": {
            //             color: "white !important",
            //           },
            //         }
            //       : {
            //           backgroundColor: "rgba(12, 55, 106, 0.5)",
            //           color: "white",
            //         }),
            //     textTransform: "capitalize",
            //   }}
            // />,
          ]}
        </Tabs>

        <TabPanel value={activeTab} index={0}>
          {!isEdit && !isSubmitYear && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {accountingYears && yearsOptions && (
                <EPRAccountingYears
                  accountingYears={accountingYears}
                  setChosenYear={setChosenYear}
                  setYearEcoApi={setYearEcoApi}
                  setAccountingPeriod={setAccountingPeriod}
                  setAllocatedYear={setAllocatedYear}
                  yearEcoApi={yearEcoApi}
                  yearOptions={yearsOptions}
                  accountingPeriod={accountingPeriod}
                />
              )}
              <Box display="flex" justifyContent="center" mt={2}>
                <Button
                  className="submit-btn-year"
                  sx={{ backgroundColor: "#00376f" }}
                  variant="contained"
                  onClick={
                    isQASubmitted
                      ? () => {
                          setIsSubmitYear(true);
                          handleNextTab();
                        }
                      : () => setIsSubmitYear(true)
                  }
                  // disabled={!isQASubmitted}
                >
                  {t("SUBMIT_YFS")}
                </Button>
              </Box>
            </Box>
          )}
          {(isSubmitYear || isEdit) && (
            <Box>
              {!isLoading && chosenYear && businessId && (
                <EPRCarousel
                  businessId={businessId}
                  setIsQASubmitted={setIsQASubmitted}
                  chosenYear={chosenYear}
                  period={accountingPeriod}
                  allocated_year={allocatedYear}
                  existingData={existingQA[0] || null}
                  setExistingData={setExistingQA}
                />
              )}
            </Box>
          )}
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <Box
            display="flex"
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              padding: 0,
            }}
            mt={2}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              sx={{ marginRight: "9.49px" }}
            >
              <Box className="next-wall-bg" sx={{ marginBottom: "12px" }}>
                <img
                  src={questionIcon}
                  alt="Question Icon"
                  width={30}
                  height={30}
                />
              </Box>
              <IconButton onClick={handlePrevTab} sx={{ cursor: "pointer" }}>
                <img
                  src={prevBtn}
                  alt="Previous Button"
                  width={40}
                  height={40}
                />
              </IconButton>
            </Box>
            <DnDParents
              businessId={businessId}
              chosenYear={chosenYear}
              setContinueBinParents={setContinueBin}
              allocatedYear={allocatedYear}
              period={accountingPeriod}
              submittedData={submittedData}
              isEdit={isEdit}
            />
          </Box>
        </TabPanel>

        <TabPanel value={activeTab} index={2}>
          <Box
            display="flex"
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              padding: 0,
            }}
            mt={2}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              sx={{ marginRight: "9.49px" }}
            >
              <Box className="next-wall-bg" sx={{ marginBottom: "12px" }}>
                <img
                  src={questionIcon}
                  alt="Question Icon"
                  width={30}
                  height={30}
                />
              </Box>
              <IconButton onClick={handlePrevTab} sx={{ cursor: "pointer" }}>
                <img
                  src={prevBtn}
                  alt="Previous Button"
                  width={40}
                  height={40}
                />
              </IconButton>
            </Box>
            <Step2Table
              continueBin={continueBin}
              businessId={businessId}
              chosenYear={chosenYear}
              period={accountingPeriod}
              allocatedYear={allocatedYear}
              setSelectedRowsInStep2={setSelectedRowsInStep2}
              selectedRowsInStep2={selectedRowsInStep2}
            />
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              sx={{ marginLeft: "9.49px" }}
            >
              <Box className="next-wall-bg" sx={{ marginBottom: "12px" }}>
                <img
                  src={
                    selectedRowsInStep2.length === 0
                      ? disabledNextSummary
                      : enabledNextSummary
                  }
                  alt="Home Icon"
                  width={30}
                  height={30}
                />
              </Box>
              <IconButton
                onClick={handleNextTab}
                sx={{ cursor: "pointer" }}
                disabled={selectedRowsInStep2.length === 0}
              >
                <img
                  src={nextBtnSummary}
                  alt="Next Button"
                  width={40}
                  height={40}
                />
              </IconButton>
            </Box>
          </Box>
        </TabPanel>

        {/* <TabPanel value={activeTab} index={3}>
          <Box
            display="flex"
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              padding: 0,
            }}
            mt={2}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              sx={{ marginRight: "9.49px" }}
            >
              <Box className="next-wall-bg" sx={{ marginBottom: "12px" }}>
                <img
                  src={questionIcon}
                  alt="Question Icon"
                  width={30}
                  height={30}
                />
              </Box>
              <IconButton onClick={handlePrevTab} sx={{ cursor: "pointer" }}>
                <img
                  src={prevBtn}
                  alt="Previous Button"
                  width={40}
                  height={40}
                />
              </IconButton>
            </Box>
            <Step2Table
              continueBin={selectedRowsInStep2}
              businessId={businessId}
              chosenYear={chosenYear}
              period={accountingPeriod}
              allocatedYear={allocatedYear}
              setSelectedRowsInStep2={setSelectedRowsInStep2}
              selectedRowsInStep2={selectedRowsInStep2}
              isView={true}
            />
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              sx={{ marginLeft: "9.49px" }}
            >
              <Box className="next-wall-bg" sx={{ marginBottom: "12px" }}>
                <img
                  src={
                    selectedRowsInStep2.length === 0
                      ? disabledNextSummary
                      : enabledNextSummary
                  }
                  alt="Home Icon"
                  width={30}
                  height={30}
                />
              </Box>
              <IconButton onClick={handleNextTab} sx={{ cursor: "pointer" }}>
                <img
                  src={nextBtnSummary}
                  alt="Next Button"
                  width={40}
                  height={40}
                />
              </IconButton>
            </Box>
          </Box>
        </TabPanel> */}
      </Paper>
      {(isSubmitYear || isEdit) && activeTab === 0 && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          sx={{ marginLeft: "9.49px" }}
        >
          <IconButton
            onClick={handleNextTab}
            disabled={!isQASubmitted}
            sx={{ marginBottom: "12px", cursor: "pointer" }}
          >
            <img src={nextBtn} alt="Next Button" width={40} height={40} />
          </IconButton>
          <Box className="next-wall-bg">
            <img
              src={nextStep1Icon}
              alt="Next Step 1 Icon"
              width={30}
              height={30}
            />
          </Box>
        </Box>
      )}
      {openQAModal && (
        <QAModalInfo
          onClick={handleProceedModal}
          onClose={() => setOpenQAModal(false)}
        />
      )}
      {openInfoModal && (
        <AllocateModal onClose={() => setOpenInfoModal(false)} />
      )}
      {openFinishModal && (
        <FinishModal
          onClose={() => setOpenFinishModal(false)}
          onClick={handleNavigate}
        />
      )}
    </Container>
  );
};

export default EPRWorkflowTabs;
